/**
 * Tabbed navigation for switching between Open, Closed, and All RMA views.
 * Each tab maps to a status_group value used for server-side filtering.
 */
import "./rma-list-tabs-bar.scss";
import { observer } from "mobx-react";
import useDashboardTranslation from "../../../../../dashboard-translation/hooks/dashboard-translation-hook";
import { IRmaListTab } from "../../../../../services/api/rma-list-service";
import { useCallback, type ReactNode } from "react";
import rmsMixpanelStore from "../../../../../stores/rms-mixpanel-store";
import rmaPagedListStore from "../../../rma-list-page/stores/rma-paged-list-store";
import TabButton from "./rma-list-tab-button";

interface ITabConfig {
    id: IRmaListTab;
    translationKey: string;
}

interface IProps {
    isLoading: boolean;
}

const STATUS_GROUP_TABS: ITabConfig[] = [
    { id: IRmaListTab.STATUS_GROUP_OPEN, translationKey: "OPEN_RMAS_TAB" },
    { id: IRmaListTab.STATUS_GROUP_CLOSED, translationKey: "CLOSED_RMAS_TAB" },
    { id: IRmaListTab.STATUS_GROUP_ALL, translationKey: "ALL_RMAS_TAB" },
];

const RmaListTabsBar: React.FC<IProps> = observer(({ isLoading }) => {
    const { getTranslation } = useDashboardTranslation();
    const scope = "dashboard-returns-page";
    const rmaListFiltersStore = rmaPagedListStore.rmaListFiltersStore;

    const onTabChange = useCallback(
        (tab: IRmaListTab) => {
            if (tab === rmaListFiltersStore.currentTab) {
                return;
            }
            rmsMixpanelStore.trackEvent("d&_tab_switched", { tab });
            rmaListFiltersStore.setCurrentTab(tab);
            rmaPagedListStore.loadPage(1);
        },
        [rmaListFiltersStore],
    );

    return (
        <div className="rma-list-tabs-bar" role="tablist">
            {STATUS_GROUP_TABS.map((tab) => (
                <TabButton
                    key={tab.id}
                    tabId={tab.id}
                    isActive={rmaListFiltersStore.currentTab === tab.id}
                    disabled={isLoading}
                    onSelect={onTabChange}
                >
                    {getTranslation(tab.translationKey, scope)}
                </TabButton>
            ))}
        </div>
    );
});

export default RmaListTabsBar;
